import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { categories } from "@/mocks/topics";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "大瓜合集", to: "/list" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [catOpen, setCatOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
    setCatOpen(false);
  }, [location.pathname, location.search]);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2.5" aria-label="吃瓜观测站 首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-mic-2-fill text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <strong className="font-heading text-lg font-bold tracking-tight text-foreground-950">
                吃瓜观测站
              </strong>
              <span className="mt-0.5 font-label text-[10px] tracking-[0.2em] text-foreground-500">
                多方说法 · 对比看
              </span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `rounded-md px-4 py-2 font-label text-sm transition-colors ${
                    isActive
                      ? "bg-primary-100 text-primary-800"
                      : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}

            <div className="relative">
              <button
                type="button"
                onClick={() => setCatOpen((v) => !v)}
                className="flex cursor-pointer items-center gap-1 rounded-md px-4 py-2 font-label text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
                aria-expanded={catOpen}
                aria-haspopup="true"
              >
                热门分类
                <i className={`ri-arrow-down-s-line transition-transform ${catOpen ? "rotate-180" : ""}`}></i>
              </button>
              {catOpen && (
                <div className="absolute right-0 top-full mt-2 w-44 overflow-hidden rounded-lg border border-background-200 bg-background-50 py-1 shadow-none">
                  {categories
                    .filter((c) => c !== "全部")
                    .map((c) => (
                      <Link
                        key={c}
                        to={`/list?category=${encodeURIComponent(c)}`}
                        className="block px-4 py-2 font-label text-sm text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-800"
                      >
                        {c}
                      </Link>
                    ))}
                </div>
              )}
            </div>
          </nav>

          <div className="hidden items-center gap-3 md:flex">
            <Link
              to="/list"
              className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-line"></i>
              看今日大瓜
            </Link>
          </div>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
            aria-label="打开菜单"
            aria-expanded={open}
          >
            <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `rounded-md px-4 py-3 font-label text-sm ${
                    isActive ? "bg-primary-100 text-primary-800" : "text-foreground-700"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <Link to="/list" className="rounded-md px-4 py-3 font-label text-sm text-foreground-700">
              热门分类
            </Link>
            <Link
              to="/list"
              className="mt-2 flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-3 font-label text-sm font-medium text-background-50"
            >
              <i className="ri-fire-line"></i>
              看今日大瓜
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}